import { IconBrandWhatsapp, IconEdit, IconFileExport, IconMail, IconTrash, IconX } from '@tabler/icons-react'
import React, { useState } from 'react'

export const MultiItemChangeBar = ({ show, setShow, onClickBulkUpdate, handleBulkUpdate, onDelete, onExport, onWhatsapp, onEmail, setSelectedItems, module_name }) => {

    return (
        <>
            {
                show &&
                <div className='w-100 d-flex align-items-center position-sticky justify-content-between '
                    style={{
                        zIndex: 999,
                        top: 10,
                        background: "#fff",
                        borderBottom: '1px solid #d3d3d3',
                        borderTopRightRadius: '8px',
                        borderTopLeftRadius: '8px',
                        padding: "0.8rem 0.5rem ",
                        animation: 'multiItemBarFadeIn 220ms ease-out',
                        transformOrigin: 'bottom center',
                    }}
                >
                    <div className='d-flex gap-2'>
                        <button
                            className="btn p-2"
                            type='button'
                            onClick={onClickBulkUpdate}
                            style={{ ...styles.btnStyle, backgroundColor: "#eaf7ff70", border: "1px solid #d0edff" }}
                        >
                            Bulk Update
                            <IconEdit size={19} stroke={2} color="blue" />

                        </button>
                        {
                            module_name === 'lead' &&
                            <>
                                <span style={{ width: '0.05rem', background: "#d3d3d3" }} />
                                <button
                                    className="btn p-2"
                                    type='button'
                                    onClick={onDelete}
                                    style={{ ...styles.btnStyle, backgroundColor: "#fff5f5", border: "1px solid #ffebeb" }}
                                >
                                    Delete
                                    <IconTrash size={19} stroke={2} color="#e03131" />
                                </button>
                            </>
                        }
                    </div>
                    <div className='d-flex gap-2'>
                        <div className='d-flex gap-2'>
                            <button
                                type="button"
                                className="btn btn-whatsapp p-2"
                                style={styles.btnStyle}
                                onClick={onWhatsapp}
                            >
                                Whatsapp
                                <IconBrandWhatsapp size={19} stroke={2} color="#fff" />
                            </button>
                            <button
                                className="btn btn-default btnss"
                                type='button'
                                style={styles.btnStyle}
                                onClick={onEmail}
                            >
                                Email
                                <IconMail size={19} stroke={2} color="#fff" />
                            </button>
                            <button
                                className="btn btn-default btnss"
                                type='button'
                                onClick={onExport}
                                style={styles.btnStyle}
                            >
                                Export
                                <IconFileExport size={19} stroke={2} color="#fff" />
                            </button>
                        </div>
                        <span style={{ width: '0.05rem', background: "#d3d3d3" }} />
                        <button
                            type='button'
                            onClick={() => {
                                setSelectedItems([])
                                setShow(false)
                            }}
                            style={{
                                background: 'none',
                                border: 'none'
                            }}
                        >
                            <IconX size={19} stroke={2} color="#e03131" />
                        </button>
                    </div>
                </div >
            }
            {/* } */}
            <style>{`
                @keyframes multiItemBarFadeIn {
                  from {
                    opacity: 0;
                    transform: translateY(12px);
                  }
                  to {
                    opacity: 1;
                    transform: translateY(0);
                  }
                }
            `}</style>

        </>
    )
}



const styles = {
    btnStyle: {
        fontSize: "13px",
        height: "30px",
        width: "auto",
        gap: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "2px",
        background: "#efefef",
        borderRadius: '8px',
        border: '1px solid #d3d3d3'
    }
}